import {AxiosError} from "axios"
import {get} from "lodash"
import GenericErrorCodes from "../../../errorCodes/Generic"

export default function (err: AxiosError) {
  const is503 = get(err, "response.status") === 503
  const isMaintenance = get(err, "response.data.code") === GenericErrorCodes.PBERRMaintenance
  const ignoreMaintenance = get(err, "config.ignoreMaintenance", false)
  return is503 && isMaintenance && !ignoreMaintenance
}
